import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMoment from "vue-moment";
var VueScrollTo = require("vue-scrollto");

// Plugins
import "./plugin/font-awesome";
import "./plugin/element-ui";

import "@/permission";

// Styles
import "./scss/reset.scss";
import "./scss/color.scss";
import "./scss/align.scss";

//API
import API from "./api/index.js";

var BASE_URL = process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_API_PORT;

API.baseURL = BASE_URL;
API.token = localStorage.getItem("token");

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();

Vue.use(store);
Vue.use(VueMoment);
Vue.use(VueScrollTo);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
